import { FaFacebook } from "react-icons/fa";

export const XIcon = ({ size = 22, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const normalizeSocialUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export const getAgencySocialLinks = (agency) => {
  const items = [
    {
      key: "twitter",
      label: "X",
      url: normalizeSocialUrl(
        agency?.twitter_profile_url ?? agency?.twitter_profile_URL,
      ),
      Icon: XIcon,
      colorClass: "text-[#000000]",
    },
    {
      key: "facebook",
      label: "Facebook",
      url: normalizeSocialUrl(
        agency?.facebook_page ?? agency?.facebook_profile_URL,
      ),
      Icon: FaFacebook,
      colorClass: "text-[#1877F2]",
    },
  ];
  return items.filter((item) => item.url);
};
